import React from 'react';
import Header from './components/Header/Header';
import Menu from './components/Menu';
import Carousel from './components/Carousel/Carousel';
import ProductsList from './components/Products/ProductsList';
import Footer from './components/Footer/Footer';

const App = () => {
  return (
    <>
      <Header />
      <Menu />
      <Carousel />
      <ProductsList />
      <Footer />
    </>
  );
}

export default App;
